export default {
    tabbar: {
        home: "トップページ",
        trading: "取引",
        invest: "投資",
        share: "分かち合う",
        mine: "私の"
    },
    common: {
        deposit: "預金",
        withdrawal: "金を引き出す",
        share: "分かち合う",
        team: "チーム",
        task: 'タスク',
        addr: 'アドレス',
        logout: "ログアウト",
        wallet: "財布",
        account: "アカウント",
        promotion: "広める",
        details: "詳細",
        dailyRevenue: '毎日の収益',
        dailyRevenueList: '日次収益リスト',
        aboutUs: "私たちについて",
        globalPartners: "グローバルパートナー",
        totalBalance: "合計残高",
        profitList: "投資信託収益リスト",
        notification: "通知",
        previous: "前の",
        close: "閉じる",
        next: "次の",
        investWallet: "投資財布",
        financialWallet: "財テク財布",
        recharge: "チャージ",
        copySucceeded: "コピー成功",
        copyFailed: "コピー失敗",
        promotionWallet: "財布を広める",
        registerRewardWallet: '財布を登録する',
        toAddress: "入金のTRON財布住所(T先頭)",
        verifyYourPassword: "パスワードを確認",
        serviceFee: 'Gas fees',
        confirm: "確認",
        submitted: "コミット済み",
        date: "日付",
        amount: "金額",
        accountAvailableBalance: "アカウント使用可能残高",
        securityPassword: "セキュリティパスワード",
        withdrawalPrincipal: '元金を引き出す',
        withdrawalProfit: '利益を引き出す',
        profitRate: '金利',
        notificationAndFAQ: 'FAQとお知らせ',
        FAQ: 'FAQ',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:プロジェクトの特徴・紹介',
                content: `R:
1. 業界初の実証済みの監査済み投資コードとして、当社のソリューションは、スマートコントラクトが投資の未来であることを証明することを目的としています。 その長命と安定性は、最終的には暗号通貨業界と人々の投資と取引に対する考え方を破壊するでしょう。 従来のトークン業界は、トークン詐欺、不正行為、市場の不安定性、不正な開発者によるユーザー資金の窃取、流動性の欠如など、多くの課題に直面しています。

2. 当社の信頼性コードはソリューションの構造に基づいており、当社のソリューションは、暗号業界で発生するこれらおよびその他の多くの課題によっていかなる形でも影響を受けません。 私たちのプラットフォームは市場の流動性を必要としません。 したがって、当社は業界の変化に依存しないため、お客様の投資と期待される収益は安全です。 代わりに、新しいユーザーの魅力に基づいて、スマート コントラクトに基づいて実行されるソリューションを構築しました。 私たちのコードと構造は安全であり、寿命と透明性が保証されています。 したがって、当社は各プロモーター/ユーザーの詳細かつ透明性のある統計を備えた、非常に魅力的で堅牢な紹介プログラムを用意しています。 オリジネーターの収益だけでなく、他のユーザーの収益も即座にプロフィールに追加され、他の DeFi 投資ソリューションとは異なり、いつでも即座に資金を引き出すことができます。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:私たちの利点は何でしょうか？',
                content: `R:当社のシステムは Haze セキュリティ チームによって監査されており、独立したスマート コントラクト監査人がいます。
1. 安全で信頼できる: 通貨を送金する必要がなく、USDT はゼロリスクで自分のウォレットに入金されます。
2.専門的な安定性：専門的なチーム、年間を通じて安定した運営
3. 参入閾値が低い: ノードマイニング収入を共有する
4.USD ETHW AI Strategy-C マイニングプール: 通貨送金不要、安定収入
5. 私たちは世界最大の統合 DeFi プラットフォーム DEX、IMO、DAO の構築に取り組んでいます。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:どうすれば参加できますか?',
                content: `R:
1. ウォレットはチェーン上にあり、ウォレット ステーションには Dapp ブラウザが装備されています。
2. TRC20をUSDTに接続し、ウォレットに入金します。
3.ウォレットブラウザからGongwangに入る
4. このプロジェクトに参加するには、ウォレットにマイニング手数料として 30 trx 以上が必要です
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:マイニングに参加するにはどのくらい時間がかかりますか?',
                content: `R:時間は計算できません。 通常は4時間以内に完了します。 その他不確実な事由が生じた場合には、時間が延長される場合があります。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:利益を現金化するためになぜマイニング手数料を支払う必要があるのでしょうか?',
                content: `R:なぜなら、マイニングに参加するこのプロセスでは、顧客は名前によってのみカウントされ、生成されたマイニング料金はマイナーによって支払われているからです。 生成された収入は実際には契約プールにあり、マイニング料金を支払うことによってのみ収入と交換できます。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:利益の出金方法は？',
                content: `R:USDTを取得した後、取引手数料のためにウォレットに少額のTRXが必要です。 支払う必要があるのは 1 回だけで、USDT 交換は法定営業日の 1 日以内に完了します。 出金を開始すると、USDT の出金は参加したノードのウォレット アドレスに自動的に送信されます。 他のアドレスはサポートされていません。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:Defi流動性マイニングとは何ですか?',
                content: `R:流動性マイニングは、DeFi 分散型金融の一種です。 グラフィックス カードを購入したり、コンピューティング能力を提供したり、高額な電気料金を支払う必要はなく、資金と流動性を提供することで収入を得ることができます。 特に最近は通貨価格の変動が激しいです。 一部の熱心なコイン保有者にとって、流動性マイニングは、取引を必要とせずに収入を獲得し、より多くの暗号通貨を蓄積する方法です。`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:どのように機能するのでしょうか?',
                content: `R:当社のソリューションは、二者間の契約条件を自動的に強制するコンピューター化された取引契約です。 ユニバーサルコントラクトと同様に、プラットフォーム上の両方のユーザーが取引時にルールと参加条件を定義する必要があります。 合意に達し、スマート コントラクトが開始されると、設計どおりに動作し、所定の条件が変更される可能性はゼロです。 ユーザーがブロックチェーン ノードのマイニング プールでアクティビティを開始するときは、契約に利用可能な残高が存在する必要があります。 残りのユーザーは契約の実行を任せることができるため、売り時や買い時を確認するために長時間待つ必要がなくなりました。 したがって、契約条件に従って、投資価値は決して減らないことが保証されています。 それどころか、ユーザーに 100% の利益をもたらします。`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: '引き出し金額は消費したガス料金より大きくなければなりません',
        supportTips: 'ユーザーの皆様へ: 私たちはあなたのために特別なマイニングプールアシスタントサービスをセットアップしました。 ご相談、苦情、提案などについては、私たちに書いていただければ、24時間以内に返信して対応させていただきます。',
        tips: 'ヒント',
        Withdrawals_prohibited: '現在、引き出し条件が満たされていません。まずタスクを完了してください。'
    },
    homePage: {
        theCommonProblem: "よくある質問",
        latestAnnouncement: "最新のお知らせ",
        block5title: "TRON百万長者になる",
        block5desc: "クラウドマイニングとDefiテクノロジーを使用して、すべてのユーザーが最高のUSDT収入を得ることを確保します。",
        block6title: "プラットフォームデータ展示",
        accumulatedProfit: "累計収益",
        membership: "会員",
        block7title: "我々は最良の状態にある",
        block7desc: "hako はシンガポールに登録されている会社です (ライセンス番号: PS20200556)。 当社は、TRON スマート チェーン (TRON) ネットワーク上で運営されている、暗号通貨分野で監査および検証された唯一のスマート コントラクト投資 Web サイトです。 hako クラウド マイニングは、ビットコイン USDT およびその他の暗号通貨に対して、潜在的にコスト効率の高いマイニング パイプラインを提供します。 同時に、クオンツ取引とDeFi技術の両方により、少額の資金で簡単にブロックチェーン取引に参加し、保険などの安定した収入を得ることが可能になります。",
        tzl: 'を投資しました',
        zl: 'を稼いだ'
    },
    investPage: {
        productList: "製品リスト",
        investedList: "投資リスト",
        dailyRate: "日利率",
        cycle: "サイクル",
        day: "日",
        productDetails: "製品の詳細"
    },
    tradingPage: {
        miningWorking: "雲掘りが働いている",
        tradingProfit: "取引収益",
        settlementRule: "24時間決済",
        viewAll: "すべて表示",
        quantifyingTransactionRevenue: "質的トレーディング収益",
        receive: "受け取る",
        received: "受領済み",
        rule: 'マイニングルール',
        rules: '「クラウドマイニング」を稼働させて毎日の収入を得たい場合は、「ファイナンシャルウォレット」で有効化してください。 ウォレット内のUSDT残高が特定の条件を満たすと、毎日収入が得られ、発生した収入は30日間保持されます。 期限内にクリックして取得してください。 以下の表に基づいて、1 日あたりの収益の割合を計算します。',
        profit: '利益',
        miningNotWorking: 'クラウドマイニングが機能していません。有効にしてください',
        balance: 'バランス'
    },
    sharePage: {
        text1: "連絡先を誘う",
        text2: "友達や奨励金をもらう",
        text3: "奨励金の推薦と獲得",
        text4: "あなたの推薦の接続を分かち合って、お金を稼ぎ始めます",
        copyLink: "接続のコピー"
    },
    minePage: {
        trxDepositInvestment: "USDT投資預金",
        trxDepositFinancial: "USDT財テク預金",
        tips: "任意の数のUSDTを預けて口座をアクティブにし、引き出し機能を開通する",
        appServices: "アプリケーションサービス"
    },
    depositPage: {
        text1: "投資は二つのモデルに分かれている。",
        text2: "1:投資財布にチャージすると、異なるサイクルで収益を得ることができ、満期時に元金と収益を返すことができます。",
        text3: "2:金融ウォレットの「クラウドマイニング」機能を有効にして、毎日シンガポールのタイムゾーン（12時以降）に応じて収入を受け取ります",
        text4: "コメント:",
        text5: "投資する前に、投資ニーズに応じて投資口座または財テク口座を選択して投資してください。必ず口座のチャージを待ってください。これは非常に重要な問題です。"
    },
    rechargePage: {
        trxAddress: "TRC20-USDTアドレス",
        copyAddress: "アドレスのコピー",
        tips1: "他のUSDT以外の資産にチャージしないでください。チャージ後約5~10分で記録します。",
        tips2: "長い間届いていない場合は、このページをリフレッシュします。最低5 USDT投資。",
        rechargeCompleted: "チャージ完了",
        inactivated: '無効化されました',
        activated: 'アクティブ化された',
        tips3: '繰り返しクリックする必要はありません。 クラウド マイニングは、リクエストが送信されてから約 5 ～ 10 分後に動作を開始します。',
        tips4: '長期間アクティベートされていない場合は、再度アクティベートボタンをクリックしてください。',
        ActivateCloudMining: 'クラウドマイニングを有効にする'
    },
    withdrawalPage: {
        text1: "基本勘定残高（USDT）",
        text2: "引き出しは24時間以内に受け取ります",
        dailyWithdrawalLimit: "日次引き出し限度額",
        unlimit: "制限なし"
    },
    teamPage: {
        intro: '直接または間接的に招待したユーザーは、配当を得ることができます。 ユーザー A を招待すると、ユーザー A が得た金銭的収入がパーセント報酬としてウォレットに送金されます。 ユーザー A がユーザー B を招待し、次に B が C を招待すると、ユーザー収入の A ({lev2rate}%)、B ({lev3rate}%)、C ({lev4rate}%) の割合の報酬を獲得できます。',
        level: "レベル",
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: "数量",
        rewards: "奨励する"
    },
    productDetailsPage: {
        startingAmount: "開始金額",
        maxInvestmentAmount: "最大投資額",
        dailyInterestRate: "日利率",
        investableQuantity: "投資可能数量",
        investmentAmount: "投資額",
        participateInInvestment: "投資に参加する"
    },
    investedListPage: {
        investmentTime: "投資時間",
        settlementTime: "決済時間",
        settlementAmount: "決済金額"
    },
    loginPage: {
        MobileNumber: "携帯番号",
        LoginPassword: "ログインパスワード",
        SignIn: "ログイン",
        SignUp: "登録",
        rememberThePassword: "パスワードを覚える",
        inviteCode: "招待コード",
        captcha: "検証コード",
        EncryptedRegistration: "暗号化された登録",
        desc: "パスワードは分散したパイプで保存されており、紛失後は取得できません。パスワードを覚えてください。 ",
        registerSuccess: "アカウントの作成に成功しました"
    },
    taskPage: {
        desc: 'あなたが登録した下級会員を招待するすべての有効なチャージ金額は一定の割合であなたの引き出し額に変換されます（普及奨励口座）',
        rwconvertRate: '変換スケール',
        totalLimit: '累計額',
        availableLimit: '使用可能額',
        contactService: 'カスタマーサービスに連絡する'
    },
    Please_unlock_your_wallet: 'ウォレットのロックを解除してください',
    Please_open_the_website_in_the_Dapp_browser: 'DappブラウザでWebサイトを開いてください'
}
